import React from 'react';
import { MapPin } from 'lucide-react';

const areas = [
  'Christchurch',
  'Islington',
  'Hornby',
  'Riccarton',
  'Sockburn',
  'Addington',
  'Sydenham',
  'Papanui',
  'Rolleston',
  'Rangiora',
  'Kaiapoi',
  'Lincoln',
  'Ashburton',
  'Timaru',
  'Greater Canterbury',
];

const AreasServedSection = () => {
  return (
    <section id="areas" className="section-padding bg-gradient-to-b from-background to-card/30 relative">
      <div className="container-wide mx-auto max-w-5xl">
        <div className="text-center mb-12">
          <p className="text-primary font-medium tracking-[0.3em] uppercase mb-4 text-sm">
            Service Area
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-bold mb-6 text-foreground">
            Vapour Blasting Across <span className="gradient-text">Canterbury</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Based in Islington, Christchurch — proudly serving customers from across the
            South Island. Drop off in person or ship parts to us from anywhere in New Zealand.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {areas.map((area) => (
            <div
              key={area}
              className="glass-card px-4 py-2 rounded-full flex items-center gap-2 text-sm text-foreground hover:border-primary transition-colors"
            >
              <MapPin className="w-4 h-4 text-primary" />
              <span>Vapour Blasting {area}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AreasServedSection;
